import { useTranslation } from 'react-i18next'

import { ArrowIcon } from '../CompanyDetail/Reports'

import { DetailsHeaderWrapper, SectionTitle, StyledCollapseContent } from './styled'

export const CheckoutItemsWrapper: React.FC = ({ children }) => {
  const { t } = useTranslation('dialogs')
  return (
    <StyledCollapseContent
      style={{ width: '100%' }}
      renderHeader={(close: boolean) => (
        <DetailsHeaderWrapper>
          <SectionTitle level="small">{t('dialogs:Transactions.Details.Title')}</SectionTitle>
          <ArrowIcon type="arrowRightBlue" opened={close} width="20px" height="20px" />
        </DetailsHeaderWrapper>
      )}
    >
      <>{children}</>
    </StyledCollapseContent>
  )
}
